import { Unit } from "../enums/unit";
import { SellingMode } from "../enums/sellingMode";

/**
 * Human-readable display labels for each Unit enum value.
 * The backend receives the enum name (e.g. `KG`, `L`, `SQCM`).
 */
export const UNIT_DISPLAY_LABELS: Record<Unit, string> = {
  [Unit.UNIT]: "Unit",
  [Unit.G]: "Gram (g)",
  [Unit.KG]: "Kilogram (kg)",
  [Unit.ML]: "Milliliter (ml)",
  [Unit.L]: "Liter (L)",
  [Unit.CM]: "Centimeter (cm)",
  [Unit.M]: "Meter (m)",
  [Unit.MM]: "Millimeter (mm)",
  [Unit.SQCM]: "Square Centimeter (cm²)",
  [Unit.OZ]: "Ounce (oz)",
  [Unit.LB]: "Pound (lb)",
  [Unit.BOTTLE]: "Bottle"
};

/**
 * Human-readable display labels for each SellingMode enum value.
 */
export const SELLING_MODE_DISPLAY_LABELS: Record<SellingMode, string> = {
  [SellingMode.SINGLE_ITEM]: "Single Item",
  [SellingMode.UNIT_BASED]: "Unit Based (Piece)",
  [SellingMode.MEASURED]: "Measured Quantity"
};
